import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ThePathToPeace() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section data-section-id="6278" id="the-nest-welcome" className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden bg-background py-20 lg:py-0">
      {}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <div className="absolute top-[-20%] left-[-10%] w-[70%] h-[70%] bg-ring/10 rounded-full blur-[120px] opacity-60 animate-pulse" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] bg-accent/50 rounded-full blur-[100px] opacity-50" />
        <div className="absolute top-[40%] left-[30%] w-[40%] h-[40%] bg-primary/5 rounded-full blur-[80px]" />
      </div>

      <div className="container relative z-10 mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-foreground tracking-tighter">Your home, <br />our nest,<br /><span className="text-[#4e26df] italic" data-ast-id="f:/src/pages/Home/sections/ThePathToPeace.tsx|sig:z2qsyl" data-ast-start="1637" data-ast-end="1830">we'll take care <br />of the rest</span></h1>
            
            

            <div className="pt-4">
              <Button asChild size="lg" className="h-14 px-10 rounded-full text-lg shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 bg-primary text-primary-foreground border-none hover:bg-ring">
                <Link to="#ready-to-scale">
                  Get Free Property Report
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative flex justify-center lg:justify-end transition-all duration-1000 delay-300 ease-out ${imageVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-10 scale-95"}`}>
            <div className="relative w-full max-w-md lg:max-w-lg aspect-square">
              {}
              <div className="absolute inset-0 border-2 border-ring/10 rounded-[60%_40%_30%_70%/60%_30%_70%_40%] animate-[spin_25s_linear_infinite] scale-105" />
              
              {}
              <div className="w-full h-full overflow-hidden rounded-[60%_40%_30%_70%/60%_30%_70%_40%] shadow-2xl shadow-primary/5 bg-muted">
                <img src="https://chubbynest.com/wp-content/uploads/2026/03/chubby-nest-image-2-transparent-scaled.png" alt="Modern high-end interior managed by Chubby Nest" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000 ease-in-out" />
              </div>

              {}
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}